import * as moment from 'moment'
export class ProfileModel {
  id: string
  latest_terms_accepted: boolean
  accepted_terms_version: any
  role: string
  last_login: any //"2018-01-11 10:16:06",
  email: string
  first_name: string
  middle_name: string
  last_name: string

  constructor(profile) {
    this.id = profile.id
    this.latest_terms_accepted = profile.latest_terms_accepted
    this.accepted_terms_version = new Date(profile.accepted_terms_version)
    this.role = profile.role

    if (profile.last_login) {
      this.last_login = moment(profile.last_login)
    }

    this.email = profile.email
    this.first_name = profile.first_name
    this.middle_name = profile.middle_name
    this.last_name = profile.last_name
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/profile.model.ts